module.exports = __webpack_public_path__ + "img/user.d0ba3bb7.png";